module.exports = __webpack_public_path__ + "static/media/mascota.e102651d.png";